const state = {
  beforeCrop: null,
  postCrop: null
};

const mutations = {
  setImage(state, payload) {
    state.beforeCrop = payload;
  },

  setFinal(state, payload) {
    state.postCrop = payload;
  },

  clearImg(state) {
    state.postCrop = null;
  }
};

const actions = {
  imageToCrop({ commit }, payload) {
    commit("setImage", payload);
  },

  afterCrop({ commit }, payload) {
    commit("setFinal", payload);
  },

  clear({ commit }) {
    commit("clearImg");
  }
};

export const cropper = {
  namespaced: true,
  state,
  actions,
  mutations
};
